<template>
	<header class="site-header">
		<div class="site-header__container">
			<div class="site-logo">
				<router-link to="/"><img src="@/assets/logo.png" alt="LOTERIE NATIONALE"></router-link>
				<router-link to="/" class="site-logo__link"><img src="@/assets/img/logo2.png" class="site-logo_header__2" alt="PMU"></router-link>
			</div>
			<!--{{breakpoint.size}}-->
			<!--{{token}}-->
			<!-- Navigation -->
         <div class="site-header__container__mode">
            <template  v-if="showSport">
               <router-link
                   to="/timeline"
                   class="btn btn-sm btn--mode-select btn--mode-select--horse"
                   :class="{'active': isHorseActive}"
                   :title="t('header.link.horse')"
               >
                  <t tag="header.link.horse"/>
               </router-link>
               <span class="site-header__container__mode__divider"></span>
               <router-link
                   to="/sport/live"
                   class="btn btn-sm btn--mode-select btn--mode-select--sport"
                   :active-class="'active'"
                   :title="t('header.link.sport.live')"
               >
                  <t tag="header.link.sport.live"/>
               </router-link>
               <span class="site-header__container__mode__divider"></span>
               <router-link
                   to="/sport/prematch"
                   class="btn btn-sm btn--mode-select btn--mode-select--sport"
                   :active-class="'active'"
                   :title="t('header.link.sport.prematch')"
               >
                  <t tag="header.link.sport.prematch"/>
               </router-link>
            </template>

         </div>
			<nav class="main-navigation" :class="{ 'is-open': nav.open }" @click.stop>
				<button class="main-navigation__trigger" @click="navToggle">
					<span class="visually-hidden">Menu</span><span class="burger" aria-hidden="true"></span>
				</button>
				<ul class="main-navigation__container">






					<li class="main-navigation__item" v-for="navItem in navList" @click="nav.open = false" :key="'nav-item-'+snakeCase(navItem.label)"
						v-if="checkRequire(navItem)">
						<nav-link :nav="navItem" class="main-navigation__link">
							<span class="raw" v-if="!navItem.translation">{{ navItem.label}}</span>
							<span class="transl" v-else>{{ t(navItem.label) }}</span>
						</nav-link>
					</li>


					<!--REGISTER - LOGIN-->
					<li class="main-navigation__item" v-if="!userLogedIn && isMobile">
						<router-link to="/register" class="main-navigation__link" v-on:click.native="refreshRegister">{{ t('header.link.register') }}</router-link>
					</li>
					<li class="main-navigation__item" v-if="!userLogedIn && isMobile">
						<router-link @click.native="nav.open = false" to="/auth" class="main-navigation__link">{{ t('header.link.login') }}</router-link>
					</li>
					<!-- SESSION TIME - LOGOUT -->
					<li class="main-navigation__item" v-if="userLogedIn && isMobile">
						<router-link :to="{ name: 'User'}" class="main-navigation__link">{{t('header.link.connected.since')}} {{sessionTime}}</router-link>
					</li>
				</ul>
			</nav>

			<!-- Login menu -->
			<transition name="fade" mode="out-in">
				<ul class="login-menu" v-if="!userLogedIn && !isMobile">
					<li class="login-menu__item">
						<router-link to="/register" class="login-menu__link" v-on:click.native="refreshRegister">{{ t('header.link.register') }}</router-link>
					</li>
					<li class="login-menu__item">
						<router-link to="/auth" class="login-menu__link login-menu__link--light">{{ t('header.link.login') }}</router-link>
					</li>
				</ul>

				<ul class="login-menu" v-if="userLogedIn && !isMobile">
					<li class="login-menu__item">
						<router-link :to="{ name: 'User'}" class="login-menu__link">{{t('header.link.connected.since')}} {{sessionTime}}</router-link>
					</li>
					<li class="login-menu__item">
						<router-link to="/logout" class="login-menu__link login-menu__link--light">{{ t('header.nav.logout') }}</router-link>
					</li>
				</ul>

				<!--<div class="account-menu" v-if="userLogedIn">
					<div class="account-menu__item account-menu__item&#45;&#45;waiting">
						<router-link :to="{name: 'User'}" class="account-menu__link">
							<span class="icon icon&#45;&#45;user-circle account-menu__item__icon" aria-hidden="true"></span>
							<div class="acount-menu__text">{{ user.firstname }} {{ user.lastname }}</div>
						</router-link>
					</div>
					<div class="account-menu__item">
						<router-link :to="{name: 'User'}" class="account-menu__link">
							<span class="icon icon&#45;&#45;money-circle account-menu__item__icon" aria-hidden="true"></span>
							<div class="acount-menu__text"><b>Solde</b> {{ (user.balance/100).toLocaleString(lang) +' €' }}
							</div>
						</router-link>
					</div>
					<div class="account-menu__item">
						<a href="#cart" class="account-menu__link">
							<span class="icon icon&#45;&#45;cart-circle account-menu__item__icon" aria-hidden="true"></span>
							<div class="acount-menu__text visually-hidden">Panier</div>
						</a>
					</div>
				</div>-->
			</transition>
		</div>
	</header>
</template>
<script>
	import Vuex from 'vuex';
	import navLink from '@/components/parts/navLink';

	export default {
		name: 'Header',
		components: {
			navLink
		},
		data() {
			return {
            showSport: false,
				nav: {
					open: false,
					list: [
						{
							id: 501,
							path: '/user/',
							label: 'header.nav.user-nav',
							login: true,
							blank: false,
							translation: true
						},
						{
							id: 502,
							path: '/timeline',
							label: 'header.nav.timeline',
							login: false,
							blank: false,
							translation: true

						},
						{
							id: 503,
							path: '/logout',
							label: 'header.nav.logout',
							login: true,
							blank: false,
							translation: true
						}
					]
				},


			}
		},
		computed: {
			...Vuex.mapState([
				'lang',
				'translations'
			]),
			...Vuex.mapGetters({
				token: 'csrf_token',
				user: 'getUser',
				userLogedIn: 'getUserStatus',
				envNav: 'getHeaderNav',
				sessionTime: 'getSessionTime'
			}),
			navList() {
				return [...this.envNav, ...this.nav.list];
			},

         isHorseActive(){
			   return this.$route.name !== 'SportLive' && this.$route.name !== 'SportPreMatch'
         }
		},
		watch: {

		},
		mounted() {
			// eslint-disable-next-line
			$(document).on('click', () => {
				this.nav.open = false;
			});

		},
		methods: {
			navToggle() {
				this.nav.open = !this.nav.open;
			},
			checkRequire(navItem) {
				return !navItem.login || (navItem.login && this.userLogedIn);
			},
			refreshRegister(){
				this.$root.$emit('register:refresh');
				this.nav.open = false;
			}
		}
	}
</script>
